export const stringContainsEmoji = (str: string) => /\p{Emoji}/u.test(str);
